import { DeviationConstants } from './deviationConstants';
import { IDeviationState } from './deviationState';
import { All as Actions } from './deviatonActions';

const initialState: IDeviationState = {
  deviationList: [],
  deviationCategoryList: [],
  errorMessage: null,
  isLoading: false,
};

export function deviation(
  state = initialState,
  action: Actions
): IDeviationState {
  switch (action.type) {
    case DeviationConstants.GET_DEVIATIONS_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case DeviationConstants.GET_DEVIATIONS_SUCCESS: {
      return {
        ...state,
        deviationList: action.payload,
        isLoading: false,
      };
    }
    case DeviationConstants.GET_DEVIATIONS_FAILURE: {
      return {
        ...state,
        errorMessage: action.error.message,
        isLoading: false,
      };
    }
    case DeviationConstants.GET_DEVIATIONS_CATEGORY_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case DeviationConstants.GET_DEVIATIONS_CATEGORY_SUCCESS: {
      return {
        ...state,
        deviationCategoryList: action.payload,
        isLoading: false,
      };
    }
    case DeviationConstants.GET_DEVIATIONS_CATEGORY_FAILURE: {
      return {
        ...state,
        errorMessage: action.error.message,
        isLoading: false,
      };
    }
    default:
      return state;
  }
}
